import { orderFieldsSchemaEndpoint } from '../constants/endpoints';
import { httpMethod, simplifyBuilder } from '../third-party';
import {
  APIOrderFieldsSchemaModel,
  APIOrderFieldsSchemaRequestModel,
} from '../types/api';

export type OrderFieldsSchemaState = {
  orderFieldsSchema: APIOrderFieldsSchemaModel;
  loadOrderFieldsSchemaPending: boolean;
  updateOrderFieldsSchemaPending: boolean;
};

export const orderCoreState: OrderFieldsSchemaState = {
  // start with a minimal valid object or cast empty object since full schema will be loaded
  orderFieldsSchema: {} as APIOrderFieldsSchemaModel,
  loadOrderFieldsSchemaPending: false,
  updateOrderFieldsSchemaPending: false,
};

export const orderFieldsSchemaBuilder = simplifyBuilder(orderCoreState, {});

export const loadOrderFieldsSchema =
  orderFieldsSchemaBuilder.createServerAction((providerId: string) => ({
    name: 'loadOrderFieldsSchema',
    url: `${orderFieldsSchemaEndpoint(providerId)}`,
    method: httpMethod.get,
    onSuccess: (
      _state: OrderFieldsSchemaState,
      payload: APIOrderFieldsSchemaModel,
    ) => ({
      orderFieldsSchema: payload,
    }),
  }));

export const updateOrderFieldsSchema =
  orderFieldsSchemaBuilder.createServerAction(
    (providerId: string, body: APIOrderFieldsSchemaRequestModel) => ({
      name: 'updateOrderFieldsSchema',
      url: `${orderFieldsSchemaEndpoint(providerId)}`,
      method: httpMethod.put,
      body,
      onSuccess: (
        _state: OrderFieldsSchemaState,
        payload: APIOrderFieldsSchemaModel,
      ) => ({
        orderFieldsSchema: payload,
      }),
    }),
  );
